import { render, staticRenderFns } from "./modalAddDashboardAnnouncements.vue?vue&type=template&id=147a91e5&"
import script from "./modalAddDashboardAnnouncements.vue?vue&type=script&lang=js&"
export * from "./modalAddDashboardAnnouncements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports